module.exports = __webpack_public_path__ + "static/img/4.5d9af63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moho/4.png
// module id = AXpP
// module chunks = 0